
/*
export function leavePopup() {
	document.addEventListener("mouseleave", function (event) {
		if (event.clientY <= 0 && document.cookie.indexOf("cookieLeaveBanner=") < 0) {
			document.body.classList.add("leave-popup-active");
		}
	});

	const overlay = document.querySelector(".leave-popup .overlay");
	const closeBtn = document.querySelector(".leave-popup .close");
	closeBtn.addEventListener("click", () => {
		ClosePopup();
	});

	overlay.addEventListener("click", () => {
		ClosePopup();
	});
	function ClosePopup() {
		let expiry = new Date();
		expiry.setTime(expiry.getTime() + (1000 * 60 * 60));
		document.cookie = "cookieLeaveBanner=yes; path=/; expires=" + expiry.toGMTString();
		document.body.classList.remove("leave-popup-active");
	}
}*/

export function leavePopup() {
	const data = window.popupData;
	const popupEl = document.querySelector('.leave-popup');
	if (!popupEl || !data) return;

	const overlay = popupEl.querySelector('.overlay');
	const photo = popupEl.querySelector('.photo');
	const photoImg = photo.querySelector('img');
	const titleEl = popupEl.querySelector('h4');
	const subtitleEl = popupEl.querySelector('p');
	const buttonHolder = popupEl.querySelector('.button-holder');
	const closeButton = popupEl.querySelector('.close');

	const POPUP_CLOSED_COOKIE = 'cookieLeaveBanner';
	const ROTATOR_INDEX_COOKIE = 'popupRotatorIndex';
	const COOKIE_EXPIRY_SECONDS = 60 * 60; // 1 hour

	// Helper to get cookie value by name
	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	// Helper to set cookie with expiry in seconds
	function setCookie(name, value, seconds) {
		const expires = new Date(Date.now() + seconds * 1000).toUTCString();
		document.cookie = `${name}=${value}; path=/; expires=${expires}`;
	}

	// Select a random rotator popup, avoiding same one during session
	function getRandomRotatorPopup() {
		if (!data.rotatorPopups || data.rotatorPopups.length === 0) return null;

		const prevIndex = parseInt(getCookie(ROTATOR_INDEX_COOKIE), 10);
		let index;

		if (data.rotatorPopups.length > 1) {
			do {
				index = Math.floor(Math.random() * data.rotatorPopups.length);
			} while (index === prevIndex);
		} else {
			index = 0;
		}

		setCookie(ROTATOR_INDEX_COOKIE, index, COOKIE_EXPIRY_SECONDS);
		return data.rotatorPopups[index];
	}

	// If popup was already closed this session, do not show again
	if (getCookie(POPUP_CLOSED_COOKIE)) return;

	function onMouseLeave(event) {
		// Only trigger when mouse leaves from top viewport edge
		if (event.clientY > 0) return;

		// Remove listener to prevent multiple triggers
		document.removeEventListener('mouseleave', onMouseLeave);

		let popupToShow = null;
		if (data.pageType === 'category' || data.pageType === 'single') {
			popupToShow = data.categoryPopup || getRandomRotatorPopup();
		} else {
			popupToShow = getRandomRotatorPopup();
		}

		if (!popupToShow) return;

		// Hide popup initially (in case it was visible)
		popupEl.style.display = 'none';

		const imgUrl = popupToShow.imgUrl || '';

		if (imgUrl) {
			// Show photo container and preload image
			photo.style.display = 'block';

			const tempImg = new Image();
			tempImg.onload = () => {
				// After image loaded, set real img src and alt
				photoImg.src = imgUrl;
				photoImg.alt = popupToShow.title || '';

				// Update text content and button
				titleEl.textContent = popupToShow.title || '';
				subtitleEl.textContent = popupToShow.subtitle || '';
				buttonHolder.innerHTML = '';

				if (popupToShow.link && popupToShow.link.url && popupToShow.link.title) {
					const a = document.createElement('a');
					a.href = popupToShow.link.url;
					a.textContent = popupToShow.link.title;
					a.className = 'button orange';
					a.target = '_blank';
					a.rel = 'noopener noreferrer';
					buttonHolder.appendChild(a);
				}

				// Show popup after image has fully loaded
				popupEl.style.display = 'flex';
				document.body.classList.add('leave-popup-active');
			};
			tempImg.onerror = () => {
				// If image fails to load, hide photo container and show popup without image
				photo.style.display = 'none';
				photoImg.src = '';
				photoImg.alt = '';

				titleEl.textContent = popupToShow.title || '';
				subtitleEl.textContent = popupToShow.subtitle || '';
				buttonHolder.innerHTML = '';

				if (popupToShow.link && popupToShow.link.url && popupToShow.link.title) {
					const a = document.createElement('a');
					a.href = popupToShow.link.url;
					a.textContent = popupToShow.link.title;
					a.className = 'button orange';
					a.target = '_blank';
					a.rel = 'noopener noreferrer';
					buttonHolder.appendChild(a);
				}

				popupEl.style.display = 'flex';
				document.body.classList.add('leave-popup-active');
			};
			tempImg.src = imgUrl;
		} else {
			// No image URL: hide photo container and show popup immediately
			photo.style.display = 'none';
			photoImg.src = '';
			photoImg.alt = '';

			titleEl.textContent = popupToShow.title || '';
			subtitleEl.textContent = popupToShow.subtitle || '';
			buttonHolder.innerHTML = '';

			if (popupToShow.link && popupToShow.link.url && popupToShow.link.title) {
				const a = document.createElement('a');
				a.href = popupToShow.link.url;
				a.textContent = popupToShow.link.title;
				a.className = 'button orange';
				a.target = '_blank';
				a.rel = 'noopener noreferrer';
				buttonHolder.appendChild(a);
			}

			popupEl.style.display = 'flex';
			document.body.classList.add('leave-popup-active');
		}
	}

	document.addEventListener('mouseleave', onMouseLeave);

	// Close popup function sets cookie and hides popup
	function closePopup() {
		setCookie(POPUP_CLOSED_COOKIE, '1', COOKIE_EXPIRY_SECONDS);
		document.body.classList.remove('leave-popup-active');
		popupEl.style.display = 'none';
	}

	closeButton.addEventListener('click', closePopup);
	overlay.addEventListener('click', closePopup);
}










// WEBPACK FOOTER //
// ./assets/js/modules/leavePopup.js